import { jsx as _jsx } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsx("g", {
    children: /*#__PURE__*/_jsx("polygon", {
      className: "line",
      points: "23.313,10.729 16.001,23.396 8.688,10.729"
    })
  });
});